// Light/dark theme support.
//
// Pages listed in THEMED_ROUTES are built on the jp-* color tokens (see index.css)
// and follow the visitor's theme. Every other page still has hardcoded dark
// styling, so it stays on the dark theme until it is converted and added here.
// Keep this list in sync with the inline script in public/index.html, which
// applies the theme before React loads to avoid a flash of the wrong colors.
export const THEMED_ROUTES = ['/', '/support', '/for-players', '/about', '/for-coaches', '/pricing', '/auth/login', '/auth/signup', '/auth/register-coach', '/auth/login-player', '/auth/addition-request', '/auth/forgot-password', '/terms', '/auth/login-selection', '/auth/plans-selection', '/auth/player-plans', '/auth/identity-verification', '/player/dashboard', '/player/profile', '/player/recruiting', '/player/messages', '/player/edit-profile'];
// Whole sections of the site that are themed, matched by path prefix.
export const THEMED_ROUTE_PREFIXES = ['/preview/', '/player/team/', '/player/profile/', '/admin', '/coach/'];

export const THEME_STORAGE_KEY = 'jp-theme';

export const isThemedRoute = (pathname) =>
  THEMED_ROUTES.includes(pathname) || THEMED_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));

export const getStoredTheme = () => {
  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    return stored === 'light' || stored === 'dark' ? stored : null;
  } catch (error) {
    return null;
  }
};

export const storeTheme = (theme) => {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (error) {
    // Storage can be unavailable (private mode); the theme still applies for this visit.
  }
};

export const getSystemTheme = () =>
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const applyTheme = (theme, pathname) => {
  const themed = isThemedRoute(pathname);
  const root = document.documentElement;
  root.dataset.theme = themed ? theme : 'dark';
  root.dataset.themed = themed ? 'true' : 'false';
};
